export const ADD_INTERCEPTED_REQUEST = 'ADD_INTERCEPTED_REQUEST';
export const ADD_INTERCEPTED_VARIABLES = 'ADD_INTERCEPTED_VARIABLES';
export const SET_INTERCEPTED_REQUESTS = 'SET_INTERCEPTED_REQUESTS';
export const SET_INTERCEPTORS = 'SET_INTERCEPTORS';
export const UPDATE_PROCESSED_REQUESTS = 'UPDATE_PROCESSED_REQUESTS';
